const API = process.env.REACT_APP_CBC_API_END_POINT || '';
const SUBDOMAIN = process.env.REACT_APP_CBC_SUBDOMAIN || '';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

const apiFetch = async (
  url,
  { method = 'GET', body = null, timeout = 8000 } = {},
) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);

  try {
    return await fetch(`${API}${url}`, {
      method,
      headers: defaultHeaders,
      credentials: 'include',
      signal: controller.signal,
      ...(body && { body: JSON.stringify(body) }),
    });
  } catch (error) {
    if (error.name === 'AbortError') {
      // eslint-disable-next-line no-console
      console.error('Request timed out');
      throw new Error('Timeout');
    }
    throw error;
  } finally {
    clearTimeout(timer);
  }
};

export const fetchWhitelabeling = (subdomain, appNameQuery) => {
  const finalSubdomain =
    subdomain && subdomain !== 'UNBRANDED'
      ? subdomain
      : SUBDOMAIN || 'UNBRANDED';
  return apiFetch(`/cbc/white_label/${finalSubdomain}?${appNameQuery}`);
};

export const createCbcSession = (prn, captchaToken) =>
  apiFetch('/cbc/session', {
    method: 'POST',
    body: { prn, recaptcha_token: captchaToken },
  });

export const fetchBalance = (prn) =>
  apiFetch(`/cbc/cardholders/${prn}/balance`);

export const fetchTransactions = (prn, page, limit, startDate, endDate) =>
  apiFetch(
    `/cbc/cardholders/${prn}/transactions?page=${page}&limit=${limit}&start_date=${startDate}&end_date=${endDate}`,
  );

export const fetchAuthorizations = (prn) =>
  apiFetch(`/cbc/cardholders/${prn}/authorizations`);
